import { render, staticRenderFns } from "./AdminAddCampusPage.vue?vue&type=template&id=2a154f5f&scoped=true&"
import script from "./AdminAddCampusPage.vue?vue&type=script&lang=js&"
export * from "./AdminAddCampusPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddCampusPage.vue?vue&type=style&index=0&id=2a154f5f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a154f5f",
  null
  
)

export default component.exports